export default {
    deliver: 'تسليم',
    receive: 'استلام',
    'remaining-materials': 'المواد المتبقية',
    'are-you-sure-you-want-to-delete-this-transfer': 'هل أنت متأكد من أنك تريد حذف المناقلة؟'
}